import translations from './SortText.translations'

export const VALUES = {
  BEST_SALES: 'product_filter_sort_best_sales',
  PRICE_ASCENDING: 'product_filter_sort_price_asc',
  PRICE_DESCENDING: 'product_filter_sort_price_desc',
}

export const getValueTranslation = (value) => {
  switch (value) {
    case VALUES.BEST_SALES:
      return translations.valueBestSales

    case VALUES.PRICE_ASCENDING:
      return translations.valuePriceAscending

    case VALUES.PRICE_DESCENDING:
      return translations.valuePriceDescending

    default:
      return null
  }
}
